/* eslint-disable quotes */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
} from '@angular/core';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

import { GoogleTagManagerService } from '@core/services/analytics/google-tag-manager.service';
import { environment } from '@env/environment';
import { getAppVersion } from '@app/modules/shared/utils/app-data.utils';
declare const window: any;

@UntilDestroy()
@Component({
  selector: 'bkg-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit, OnChanges {
  @Input() cookiesAccepted: boolean;
  @ViewChild('google_container') googleContainer: ElementRef;
  public appVersion = getAppVersion();

  constructor(
    private translateService: TranslateService,
    private googleTagManagerService: GoogleTagManagerService

  ) { }

  selectedLang: string;

  get isDesktop(): boolean {
    return window.screen.width >= 1000;
  }

  private browserGlobals = {
    windowRef(): any {
      return window;
    },
    documentRef(): any {
      return document;
    },
  };

  getDefaultLang(): string {
    return this.translateService.getDefaultLang();
  }

  ngOnInit(): void {
    this.selectedLang = this.translateService.getDefaultLang();
    this.subscribeToLangChange();
    if (this.cookiesAccepted) {
      this.initData();
    }
  }

  ngOnChanges(): void {
    if (this.cookiesAccepted) {
      this.initData();
    }
  }

  private subscribeToLangChange(): void {
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe(({ lang }: LangChangeEvent) => {
        this.googleTagManagerService.pushOnDataLayer({
          event: `change-${lang}`,
        });
        this.googleTagManagerService.pushBookingActionOnDataLayer({
          event_name: `change-${lang}`,
        });
        this.selectedLang = lang;
      });
  }

  get getPrivacyLink(): string {
    const link = this.translateService.instant(
      'sharedModule.bkgFooter.privacyLink'
    ) as string;
    return environment.PUBLIC_URL + link;
  }

  get getLegalLink(): string {
    const link = this.translateService.instant(
      'sharedModule.bkgFooter.legalLink'
    ) as string;
    return environment.PUBLIC_URL + link;
  }

  get getSiteMapLink(): string {
    const link = this.translateService.instant(
      'sharedModule.bkgFooter.siteMapLink'
    ) as string;
    return environment.PUBLIC_URL + link;
  }

  initData(): void {
    const _self = this;
    const doc = this.browserGlobals.documentRef();
    const ekomiConfig = doc.createElement('script');
    ekomiConfig.innerHTML =
      "(function (w) {w['_ekomiWidgetsServerUrl'] = 'https://widgets.ekomi.com';w['_customerId'] = 139290;w['_language'] = 'es';if (typeof w['_ekomiWidgetTokens'] !== 'undefined') { w['_ekomiWidgetTokens'][w['_ekomiWidgetTokens'].length] = 'sf1392905efde66aaff03'; } else { w['_ekomiWidgetTokens'] = new Array('sf1392905efde66aaff03');} if (typeof ekomiWidgetJs == 'undefined') {ekomiWidgetJs = true;var scr = document.createElement('script');scr.src = 'https://sw-assets.ekomiapps.de/static_resources/widget.js';var head = document.getElementsByTagName('head')[0];head.appendChild(scr);}})(window);";
    doc.head.insertBefore(ekomiConfig, doc.head.firstChild);

    const googleConfig = doc.createElement('script');
    googleConfig.id = 'GWidgetscript';
    googleConfig.async = true;
    googleConfig.src = 'https://apis.google.com/js/platform.js';
    googleConfig.onload = function (): void {
      _self.loadGoogleWidget();
    };
    doc.head.insertBefore(googleConfig, doc.head.firstChild);
  }

  loadGoogleWidget(): void {
    if (!this.googleContainer?.nativeElement.hasChildNodes()) {
      const ratingBadgeContainer = document.createElement('div');
      this.googleContainer?.nativeElement.appendChild(ratingBadgeContainer);
      window.gapi.load('ratingbadge', function () {
        window.gapi.ratingbadge.render(ratingBadgeContainer, {
          // REQUIRED
          merchant_id: '193046350',
          // OPTIONAL
          position: 'INLINE',
        });
      });
    }
  }
}
